// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reported-duration__date .sk-month-calendar__wrapper.sk-date-picker__calendar {\n  top: -2px;\n  left: -230px;\n  margin-top: 0;\n  -webkit-transform: translate(0, -100%);\n          transform: translate(0, -100%);\n}\n", ""]);
// Exports
module.exports = exports;
